'use strict';

/**
 * Collection for object attributes
 *
 * @category   Collection
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');

var SpeciesCollection = Collection.extend({
    api: '/species',

    name: 'collection:species',
});

module.exports = SpeciesCollection;